import React, { FC } from "react";
import foodCategoryIconsMap from "assets/icons/foodCategory/foodCategoryIcons";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";

export interface IFoodCategory {
  id: string;
  size?: number;
  zindex?: number;
}

const FoodCategories: React.FC<IFoodCategory> = ({
  id,
  size = 40,
  zindex = 10,
}) => {
  const { resolution } = useScreenStore();
  const IconComponent = foodCategoryIconsMap[id];

  if (!IconComponent) {
    return <></>;
  }

  return (
    <IconComponent
      style={{
        minWidth: resolution === ResolutionType.FULL_HD ? 60 : 40,
        zIndex: zindex,
      }}
      width={size}
      height={size}
    />
  );
};

export default FoodCategories;
